import { memo, lazy, useState, useEffect, Suspense } from 'react';
import { styled } from 'goober';

const Cards = lazy(() => import('./Cards'));

const StatusMessage = styled.p`
  font-family: 'Noto Sans', sans-serif;
  font-size: 16px;
  line-height: 18px;
  color: #242527;
`;

const TopicCards = ({ lessonId }) => {
  const [cards, setCards] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      fetch(`/api/curriculum/lesson_cards/${lessonId}`)
        .then((data) => data.json())
        .then((x) => {
          setCards(x);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsError(true);
          setIsLoading(false);
          // eslint-disable-next-line no-console
          console.error(error);
        });
    }, 0);
  }, []);
  return (
    <>
      {isLoading && <StatusMessage>Loading...</StatusMessage>}
      {isError && <StatusMessage>Server Error!</StatusMessage>}
      {cards && (
        <Suspense fallback={<p>Loading...</p>}>
          <Cards cards={cards} />
        </Suspense>
      )}
    </>
  );
};

export default memo(TopicCards);
